import angular from 'angular';
import internalSystemOptionDirective from './internal-system-option.directive';


export default angular.module('app.components.advisory.enterpriseModeling.internalSystemOption', [])
  .directive('emInternalSystemOption', internalSystemOptionDirective)
  .controller('InternalSystemOptionController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.enterpriseModeling.internalSystemOption created');
